<script setup lang="ts">
/* @ts-ignore */
import DropdownMenu from 'v-dropdown-menu'
import 'v-dropdown-menu/css'
const props = defineProps({
  mode: {
    type: String,
    default: 'hover'
  }
})
</script>

<template>
  <dropdown-menu :mode="props.mode" direction="center" :overlay="false">
    <template #trigger>
      <slot name="trigger" />
    </template>

    <template #header>
      <slot name="header" />
    </template>

    <template #body>
      <slot name="body" />
    </template>

    <template #footer>
      <slot name="footer" />
    </template>
  </dropdown-menu>
</template>
<style>
.v-dropdown-menu__container {
  min-width: 181px;
  @apply shadow-md rounded-[20px];
}
</style>
